export default __webpack_public_path__ + "static/tooltip-contents-do-light-694608dead34a8ac6558a371c2cb5ce1dfc399a35422ba485fc1f48b6c3003ec.png";